import React from 'react'
import ReactMarkdown from 'react-markdown'
import { Link, withRouter } from 'react-router-dom'
import UIkit from 'uikit'
import settings from 'settings'

import ReactAudioPlayer from 'react-audio-player'

// Components
import ChallengeProof from 'app/views/components/ChallengeProof'
import ModalCompletedLesson from 'app/views/components/Modals/ModalCompletedLesson'
import ModalHint from 'app/views/components/Modals/ModalHint'
import SubscriptionHelp from 'app/views/components/Subscription/SubscriptionHelp'

// Utils
import analytics from 'app/views/utils/analytics'

class LessonSteps extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      currentStep: null, // only use this for filtering hints and showing product tour
      autoPlayAudio: false,
      hide: false,
    }
    this.isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
    this.handleClickBack = this.handleClickBack.bind(this)
    this.handleClickCircle = this.handleClickCircle.bind(this)
    this.handleClickDeveloperTraining = this.handleClickDeveloperTraining.bind(this)
    this.handleClickDone = this.handleClickDone.bind(this)
    this.handleClickNext = this.handleClickNext.bind(this)
    this.handleOnReset = this.handleOnReset.bind(this)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.currentProgress !== null
      && nextProps.currentProgress !== this.props.steps.length
      && this.state.currentStep === null
    ) {
      this.setState({
        currentStep: nextProps.currentProgress + 1,
      })
    }
  }

  handleOnReset() {
    this.props.onSandboxReset()
  }

  handleClickBack(index) {
    if (this.props.onClickBack !== undefined) {
      this.props.onClickBack(index - 1)
    }
    // update currentStep state for hint filtering
    this.setState({ currentStep: this.state.currentStep - 1 }, () => {
      if (this.isSafari) {
        document.getElementsByTagName('html')[0].style.width = '99.5%'
        setTimeout(() => {
          document.getElementsByTagName('html')[0].style.width = '100%'
        }, 10)
      }
    })
    this.props.lessonStepContainerRef.scrollTop = 0
    this.props.lessonStepContainerRef.scrollLeft = 0
  }

  handleClickCircle(index) {
    if (this.props.onClickBack !== undefined) {
      this.props.onClickCircle(index)
    }

    // update currentStep state for hint filtering
    this.setState({ currentStep: index + 1 }, () => {
      if (this.isSafari) {
        document.getElementsByTagName('html')[0].style.width = '99.5%'
        setTimeout(() => {
          document.getElementsByTagName('html')[0].style.width = '100%'
        }, 10)
      }
    })
  }

  handleClickDeveloperTraining() {
    analytics.track('Learn More (CTA)')
    window.location.assign(`${settings.urls.www}/secure-development-training`)
  }

  handleClickDone(index) {
    this.modalCompleted.show()
    if (this.props.onClickDone !== undefined) {
      this.props.onClickDone(index + 1)
    }
  }

  handleClickNext(index) {
    if (this.props.onClickNext !== undefined) {
      this.props.onClickNext(index + 1)
    }

    this.setState({ currentStep: this.state.currentStep + 1 }, () => {
      if (this.isSafari) {
        document.getElementsByTagName('html')[0].style.width = '99.5%'
        setTimeout(() => {
          document.getElementsByTagName('html')[0].style.width = '100%'
        }, 10)
      }
    })
    this.props.lessonStepContainerRef.scrollTop = 0
    this.props.lessonStepContainerRef.scrollLeft = 0
  }

  render() {
    let audioUrl = null
    const stepKey = this.state.currentStep - 1
    if (
      this.props.email !== null
      && this.props.email.endsWith('hackedu.io')
      && this.props.contentType === 'topic'
      && this.props.steps.includes(stepKey)
      && this.props.steps[stepKey].audio_url !== null
    ) {
      audioUrl = `${settings.urls.cdn}${this.props.steps[stepKey].audio_url}`
    }

    return (
      <div>
        <div className="uk-container uk-padding-small" id="skill-steps">
          <h1>{this.props.title}</h1>
          {(audioUrl) && (
            <ReactAudioPlayer
              src={audioUrl}
              autoPlay={this.state.autoPlayAudio}
              controls
              style={{ height: '55px' }}
              className="uk-margin-bottom"
              onPlay={() => { this.setState({ autoPlayAudio: true }) }}
              onPause={() => { this.setState({ autoPlayAudio: false }) }}
            />
          )}
          <div className="uk-margin-small-bottom">

            {(
              this.props.description !== ''
              && (
                this.props.contentType === 'practice'
                || this.props.contentType === 'challenge'
              )
            ) && (
                <p>{this.props.description}</p>
              )}

            {(Object.keys(this.props).includes('steps') && this.props.steps.length > 0) && (
              <div id="skill-steps">
                {/* animation: uk-admination-slide-right-medium, uk-animation-slide-left-medium */}
                <ul className="uk-dotnav" data-uk-switcher="">
                  {this.props.steps.map((step, index) => {
                    let className = ''
                    if (this.props.currentProgress === index) {
                      className = 'uk-active'
                    } else if (this.props.currentProgress === undefined && index === 0) {
                      className = 'uk-active'
                    }
                    let style = {}
                    if (this.props.steps.length < 2) {
                      style = { display: 'none' }
                    }
                    return (
                      <li className={className} key={step.id} style={style}>
                        <button
                          onClick={() => { this.handleClickCircle(index) }}
                          style={{ padding: 0 }}
                          type="button"
                        />
                      </li>
                    )
                  })}
                </ul>
                {(this.state.currentStep === 1 && (this.props.ecsTaskDefinition === 'was1_sqli')) && (
                  <button
                    className="uk-button uk-button-primary uk-margin-top"
                    onClick={() => { UIkit.modal('#modal-lesson-tour').show() }}
                    type="button"
                  >
                    Product Tour
                  </button>
                )}
                <ul className="uk-switcher uk-margin">
                  {this.props.steps.map((step, index) => (
                    <li key={step.id}>
                      <div>
                        <ReactMarkdown
                          escapeHtml={false}
                          linkTarget="_blank"
                          source={step.markdown}
                        />
                      </div>
                      {(step.hints.length > 0) && (
                        <div>
                          <button
                            className="uk-button"
                            data-uk-toggle={`#modal-hint-${step.id}`}
                            id="hint-button"
                            style={{
                              width: '100%',
                              backgroundColor: '#e9ecef',
                              color: '#333',
                            }}
                            type="button"
                          >
                            Hint
                          </button>
                          <ModalHint
                            hints={step.hints}
                            stepId={step.id}
                          />
                        </div>
                      )}

                      <div className="uk-margin">
                        {(index > 0) && (
                          <button
                            className="uk-button uk-button-muted uk-button-small"
                            data-uk-switcher-item={index - 1}
                            onClick={() => { this.handleClickBack(index) }}
                            data-test-id="lesson-steps-back-button"
                            type="button"
                          >
                            Back
                          </button>
                        )}
                        {(index < this.props.steps.length - 1) && (
                          <button
                            data-test-id="lesson-steps-next-button"
                            className="uk-button uk-button-secondary uk-button-small uk-align-right"
                            data-uk-switcher-item="next"
                            onClick={() => { this.handleClickNext(index) }}
                            type="button"
                          >
                            Next
                          </button>
                        )}
                        {(index === this.props.steps.length - 1) && (
                          <button
                            type="button"
                            className="uk-button uk-button-primary uk-button-small uk-align-right"
                            onClick={() => { this.handleClickDone(index) }}
                            data-uk-toggle="target: #modal-completed-lesson"
                          >
                            Done
                          </button>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>

                <ModalCompletedLesson
                  onRef={(ref) => { this.modalCompleted = ref }}
                  title={this.props.title}
                  confirmURL={this.props.lessonCompletionURL}
                  confirmText={this.props.lessonCompletionText}
                  latestCodePassed={this.props.latestCodePassed}
                  latestCodePatchId={this.props.latestCodePatchId}
                  mustPassCodingExercise={this.props.mustPassCodingExercise}
                  hasTest={this.props.hasTest}
                  ecsTaskDefinition={this.props.ecsTaskDefinition}
                  idToken={this.props.idToken}
                  contentId={this.props.contentId}
                  codeSubmissions={this.props.codeSubmissions}
                />

              </div>
            )}
          </div>

        </div>

        {(this.props.contentType === 'vulnerability') && (
          <div className="uk-card uk-card-default uk-card-body uk-text-center uk-margin-medium-top">
            <h3 className="uk-margin-small-top">
              Like what you see?
            </h3>
            <p>
              Learn more about the lessons in our Secure Development Training.
            </p>
            <button
              type="button"
              className="uk-button uk-button-primary"
              onClick={this.handleClickDeveloperTraining}
            >
              Learn More
            </button>
          </div>
        )}

        {(this.props.contentType === 'challenge') && (
          <div>
            <ChallengeProof
              id={this.props.contentId}
              userId={this.props.userId}
            />
            <SubscriptionHelp contentType={this.props.contentType} />
          </div>
        )}

        {(this.props.contentType === 'practice') && (
          <SubscriptionHelp contentType={this.props.contentType} />
        )}

      </div>
    )
  }
}


export default withRouter(LessonSteps)
